import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

const EMPTY = { reward_id: '', name: '', cost: '', type: '', sort_order: 0, active: true };

export default function CouponRewardPanel() {
  const [rewards, setRewards] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState(null);

  const fetchRewards = () => {
    api.get('/admin/coupon-rewards').then(setRewards).catch(() => {});
  };

  useEffect(fetchRewards, []);

  const handleSave = async () => {
    if (!form.reward_id || !form.name || !form.cost || !form.type) return;
    setMsg(null);
    try {
      if (editing) {
        await api.put(`/admin/coupon-rewards/${editing}`, form);
      } else {
        await api.post('/admin/coupon-rewards', form);
      }
      setEditing(null);
      setForm(EMPTY);
      fetchRewards();
      setMsg({ type: 'success', text: editing ? 'Updated' : 'Created' });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this reward?')) return;
    try {
      await api.delete(`/admin/coupon-rewards/${id}`);
      fetchRewards();
    } catch {
      // ignore
    }
  };

  const startEdit = (r) => {
    setEditing(r.id);
    setForm({
      reward_id: r.reward_id,
      name: r.name,
      cost: r.cost,
      type: r.type,
      sort_order: r.sort_order,
      active: r.active,
    });
  };

  return (
    <div className="card">
      <h3 style={{ marginBottom: 12 }}>Stash Shop Rewards</h3>

      {msg && (
        <div style={{ padding: '8px 12px', borderRadius: 'var(--radius-sm)', marginBottom: 12, fontSize: 13,
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}

      <div style={{ overflowX: 'auto', marginBottom: 16 }}>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Name</th>
              <th>Cost</th>
              <th>Type</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rewards.map(r => (
              <tr key={r.id}>
                <td>{r.sort_order}</td>
                <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{r.reward_id}</td>
                <td>{r.name}</td>
                <td style={{ color: 'var(--warning)', fontWeight: 600 }}>{r.cost}</td>
                <td>{r.type}</td>
                <td>{r.active ? 'Yes' : 'No'}</td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn-primary btn-small" onClick={() => startEdit(r)}>Edit</button>
                    <button className="btn-danger btn-small" onClick={() => handleDelete(r.id)}>Del</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ background: 'var(--bg-secondary)', borderRadius: 'var(--radius-sm)', padding: 16 }}>
        <h4 style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 12 }}>
          {editing ? 'Edit Reward' : 'Add Reward'}
        </h4>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8, marginBottom: 12 }}>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Sort Order</label>
            <input type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order: parseInt(e.target.value) || 0 }))} />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Reward ID</label>
            <input type="text" value={form.reward_id} onChange={e => setForm(f => ({ ...f, reward_id: e.target.value }))} placeholder="e.g. 3.5g" />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Name</label>
            <input type="text" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. 3.5g Eighth" />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Cost (points)</label>
            <input type="number" value={form.cost} onChange={e => setForm(f => ({ ...f, cost: e.target.value }))} placeholder="e.g. 1875" />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Type</label>
            <input type="text" value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} placeholder="e.g. 3.5g" />
          </div>
          <div>
            <label style={{ fontSize: 11, color: 'var(--text-muted)' }}>Active</label>
            <select value={form.active ? 'true' : 'false'} onChange={e => setForm(f => ({ ...f, active: e.target.value === 'true' }))}>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-primary btn-small" onClick={handleSave}>{editing ? 'Update' : 'Add'}</button>
          {editing && <button className="btn-secondary btn-small" onClick={() => { setEditing(null); setForm(EMPTY); }}>Cancel</button>}
        </div>
      </div>

      <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 8, marginBottom: 0 }}>
        These rewards appear in the Stash Shop where users spend Bud Points.
      </p>
    </div>
  );
}
